$(document).on("click keydown", ".js-sidebar_nav_toggle", function(e){
    if(e.key !== "Enter" && e.key!== " " && e.type !== "click") return;
    e.preventDefault();
    if($(this).hasClass("fa-plus")){
        $(this).removeClass("fa-plus").addClass("fa-minus");
        $(this).siblings(".js-sidebar_nav").slideDown(100);
    }else{
        $(this).removeClass("fa-minus").addClass("fa-plus");
        $(this).siblings(".js-sidebar_nav").slideUp(100);
        $(this).siblings(".js-sidebar_nav").find(".js-sidebar_nav").hide();
        $(this).siblings(".js-sidebar_nav").find(".js-sidebar_nav_toggle").removeClass("fa-minus").addClass("fa-plus");
    }
})